//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Formboard.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[0,"CgmflBrsr",1,0],[1,"CompSel",0,"SelectNXObject",0],[0,"DestEnum",1,0],[0,"PntOrigin",1,"Point",0],[0,"StrAnnot",1,0],[0,"StrAnnotFileName",1,0],[0,"TogBlank",1,0],[0,"Type",1,0]],[],[]];
SPLM.Formboard.FaceAnnotationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Formboard.FaceAnnotationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Formboard.FaceAnnotationBuilder.Types = Object.freeze({
    "ComponentAttribute" : "ComponentAttribute", "CgmFileSelection" : "CgmFileSelection", "PatternFileSelection" : "PatternFileSelection"});

SPLM.Formboard.FaceAnnotationBuilder.DrwDestination = Object.freeze({
    "DrawingSheet" : "DrawingSheet", "Model" : "Model"});

export default SPLM;